var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSingleSelect = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip0_687_520)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#E3F5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 16c-1 0-2 .895-2 2s1 2 2 2h9c1.1 0 2-.9 2-2s-.9-2-2-2h-9zM5 16c-1 0-2 .895-2 2s1 2 2 2c1.1 0 2-.9 2-2s-.9-2-2-2z",
    fill: "#5FC8FF",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10c-1 0-2 .895-2 2s1 2 2 2h9c1.1 0 2-.9 2-2s-.9-2-2-2h-9zM5 10c-1 0-2 .895-2 2s1 2 2 2c1.1 0 2-.9 2-2s-.9-2-2-2zM10 4c-1 0-2 .895-2 2s1 2 2 2h9c1.1 0 2-.9 2-2s-.9-2-2-2h-9zM5 4c-1 0-2 .895-2 2s1 2 2 2c1.1 0 2-.9 2-2s-.9-2-2-2z",
    fill: "#5FC8FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip0_687_520"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#fff"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSingleSelect);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/single-select.45c706d959729f606a78eaf459b85444.svg";